/**
 * records-context.js
 */

import React, { useState } from "react";


export const RecordsContext = React.createContext();


export const RecordsProvider = ({children}) => {
  const [state, setState] = useState({
    searchOptions: null,
    isReportDialogOpen: false,
    isFilterOpen: false,
    isSearchSaveOpen: false
  });


  // searchOptions can be value or function
  const setSearchOptions = React.useCallback((searchOptions) => {
    setState(p => ({
      ...p,
      searchOptions: typeof searchOptions === 'function' ? searchOptions(p.searchOptions) : searchOptions
    }));
  }, []);


  const setIsReportDialogOpen = React.useCallback((isReportDialogOpen) => {
    setState(p => ({ 
      ...p, 
      isReportDialogOpen 
    }));
  }, []);


  const setIsFilterOpen = React.useCallback((isFilterOpen) => {
    setState(p => ({
      ...p,
      isFilterOpen
    }));
  }, []);


  const setIsSearchSaveOpen = React.useCallback((isSearchSaveOpen) => {
    setState(p => ({
      ...p,
      isSearchSaveOpen
    }));
  }, []);

  
  const value = React.useMemo(() => ({
    ...state,
    setSearchOptions,
    setIsReportDialogOpen,
    setIsFilterOpen,
    setIsSearchSaveOpen,
  }), [
    state,
    setSearchOptions,
    setIsReportDialogOpen,
    setIsFilterOpen,
    setIsSearchSaveOpen,
  ]);


  return (
    <RecordsContext.Provider value={value}>
      {children}
    </RecordsContext.Provider>
  );
};